import { combineReducers } from '@reduxjs/toolkit';
import createEntityReducer from '../pages/Create/CreateSlice';
import homeReducer from '../pages/Home/HomeSlice';
import legalEntityReducer from '../pages/LegalEntity/LegalEntitySlice';

const reducer = combineReducers({
  home: homeReducer,
  legalEntity: legalEntityReducer,
  createEntity: createEntityReducer,
});
export default reducer;
